// removed by extract-text-webpack-plugin
module.exports = {"from":"transaction_from_3Ow3kR1FKV","txhash":"transaction_txhash_o0GbF7ucPC","transaction":"transaction_transaction_N5sWQNaRuv","local":"transaction_local_1OGBtXS3oe","nowrap":"transaction_nowrap_3tez5zZhA4","edit":"transaction_edit_2IXKur79Ih"};


//////////////////
// WEBPACK FOOTER
// ./Transaction/transaction.css
// module id = 499
// module chunks = 0